import { Routes } from '@angular/router';
import { AuditLogsModule } from 'app/pages/audit-logs/audit-logs.module';
import { CompaniesModule } from 'app/pages/companies/companies.module';
import { FinancialTransactionsModule } from 'app/pages/financial-transactions/financial-transactions.module';
import { ModulesModule } from 'app/pages/modules/modules.module';
import { PaymentRequestsModule } from 'app/pages/payment-requests/payment-requests.module';
import { PaymentActionsModule } from 'app/pages/payment-actions/payment-actions.module';
import { EmailMessagesModule } from 'app/pages/email-messages/email-messages.module';
import { SmsMessagesModule } from 'app/pages/sms-messages/sms-messages.module';
import { UsersModule } from 'app/pages/users/users.module';
import { DocumentIntelligenceModule } from 'app/pages/document-intelligence/document-intelligence.module';
import { SettingsModule } from 'app/pages/settings/settings.module';
import { BankTransactionModule } from 'app/pages/bank-transactions/bank-transaction.module';

// Route for content layout with sidebar, navbar and footer
export const FullLayoutRoutes: Routes = [
  {
    path: 'companies',
    loadChildren: () => CompaniesModule
  },
  {
    path: 'financial-transactions',
    loadChildren: () => FinancialTransactionsModule
  },
  {
    path: 'modules',
    loadChildren: () => ModulesModule
  },
  {
    path: 'payment-requests',
    loadChildren: () => PaymentRequestsModule
  },
  {
    path: 'payment-actions',
    loadChildren: () => PaymentActionsModule
  },
  {
    path: 'email-messages',
    loadChildren: () => EmailMessagesModule
  },
  {
    path: 'sms-messages',
    loadChildren: () => SmsMessagesModule
  },
  {
    path: 'audit-logs',
    loadChildren: () => AuditLogsModule
  },
  {
    path: 'users',
    loadChildren: () => UsersModule
  },
  {
    path: 'document-intelligence',
    loadChildren: () => DocumentIntelligenceModule
  },
  {
    path: 'bank-transactions',
    loadChildren: () => BankTransactionModule
  },
  {
    path: 'settings',
    loadChildren: () => SettingsModule
  }
];
